import { render, staticRenderFns } from "./ExclusiveOffersCarousel.vue?vue&type=template&id=1566897b&scoped=true&"
import script from "./ExclusiveOffersCarousel.vue?vue&type=script&lang=js&"
export * from "./ExclusiveOffersCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ExclusiveOffersCarousel.vue?vue&type=style&index=0&id=1566897b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566897b",
  null
  
)

export default component.exports